import * as React from 'react';
import cn from 'classnames';
import Spline from '@splinetool/react-spline';
import CTA from 'react-scale/components/elements/cta';
import Partners from './partners';
import Header from 'react-scale/components/elements/header';
import { themeDark } from 'react-scale/components/elements/header/header-themes';
import { useDeviceDetect } from 'react-scale/hooks/use-device-detect';
import Section from 'react-scale/components/elements/section';

import s from './hero.module.scss';

export const Hero = ({ announcementBannerData }) => {
  const [isSplineLoading, setIsSplineLoading] = React.useState(true);
  const { isTouch } = useDeviceDetect();

  return (
    <>
      {/* @ts-ignore: Unreachable code error */}
      <Header
        canonical="https://scale.com/"
        theme={themeDark}
        prefetchedData={announcementBannerData}
      />
      <Section paddingTop={false} paddingBottom={false}>
        <div className="py-12 md:pb-0 xl:pt-20">
          <div className="lg:grid lg:grid-cols-3">
            <div className="relative z-10 col-span-2">
              <h1 className="text-5xl font-light leading-tight sm:text-7xl xl:text-8xl xl:text-[105px] font-aeonik">
                <div>
                  Power
                  <div className={s.cubespinner}>
                    {' '}
                    <div className={s.face1}>Generative AI</div>
                    <div className={s.face2}>Automotive AI</div>
                    <div className={s.face3}>Government AI</div>
                  </div>
                </div>
                <br /> With Your&nbsp;Data
              </h1>
              <p className="mb-10 text-base leading-normal lg:pr-12 lg:mt-8 lg:text-lg md:w-11/12 3xl:w-full lg:mb-12 mt-6">
                Make the best models with the best data. Scale Data Engine leverages your enterprise
                data, and with Scale Generative AI Platform, safely unlocks the value of&nbsp;AI.
              </p>
              <div className="w-full mb-16 md:w-2/3 md:flex-row md:space-x-4 md:mb-0">
                {/* @ts-ignore: Unreachable code error */}
                <CTA
                  cta={{
                    buttons: [
                      {
                        text: 'Book a Demo',
                        href: '/demo',
                        type: 'primary'
                      },
                      {
                        text: 'Build AI',
                        href: '/data-engine',
                        type: 'secondary'
                      }
                    ]
                  }}
                />{' '}
              </div>
            </div>
            {!isTouch && (
              <div className="relative lg:flex items-center hidden">
                <div className="md:block hidden absolute z-0 top-24 lg:left-1/3 lg:-translate-x-1/2 lg:top-1/3 lg:-translate-y-1/2 3xl:top-1/2 3xl:left-1/2 3xl:-translate-y-1/2 w-full md:w-96 md:h-96 lg:w-[400px] lg:h-[400px] 3xl:w-[512px] 3xl:h-[512px] opacity-70 md:opacity-100">
                  <Spline
                    scene="https://prod.spline.design/RDus3exieCC8copI/scene.splinecode"
                    onLoad={() => setIsSplineLoading(false)}
                    className={cn('transition-all duration-1000', {
                      'blur-xl': isSplineLoading
                    })}
                  />
                </div>
              </div>
            )}
          </div>

          <Partners />
        </div>
      </Section>
    </>
  );
};
